// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.w-select-options[data-v-f3ca35ce]:focus{\n\toutline: none;\n}\n.context-menu-item[data-v-f3ca35ce]{\n\tcolor:var(--main-gray-6);\n}\n.context-menu-item-icon[data-v-f3ca35ce]{\n\twidth: 15px;\n}\n*:hover>.context-menu-item[data-v-f3ca35ce]{\n\tcolor:#fff;\n\tbackground: var(--main-blue-5);\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
